import React, { FC, useCallback } from 'react'

import useToggle from 'Hooks/useToggle'

import ForgotPasswordModal from '../ForgotPasswordModal'
import PasswordField from '../PasswordField'

const Password: FC = () => {
  const [forgotPasswordModalVisibility, , openForgotPasswordModal, closeForgotPasswordModal] = useToggle()

  const handleForgotPasswordClick = useCallback(() => {
    openForgotPasswordModal()
  }, [openForgotPasswordModal])

  return (
    <div>
      <div className="form-group">
        <div className="d-flex align-items-center">
          <label className="col-sm-4 mb-0 mr-3" htmlFor="customer-password">
            Password
          </label>

          <PasswordField required autoComplete="current-password" />
        </div>
      </div>

      <div className="col-sm-10">
        <a className="text-underline" onClick={handleForgotPasswordClick}>
          Forgot your password?
        </a>
      </div>
      <div>{forgotPasswordModalVisibility ? <ForgotPasswordModal closeModal={closeForgotPasswordModal} /> : null}</div>
    </div>
  )
}

export default Password
